module.exports = __webpack_public_path__ + "static/1215-b31372858d0084654173ba4f271c135d.png";